'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');
var convertHelper = require('../../types/convertHelper');
var styleHelper = require('../../helper/styleHelper');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var CustomRect = require('../common/CustomRect');
var util = require('../../helper/util');
var propConst = require('../../constants/propConst');

/*
 * 列表组件
 */

var ListItem = React.createClass({

  propTypes: {
    selected: React.PropTypes.bool.isRequired,
    partStyle: React.PropTypes.object,
    showDivisionLine: React.PropTypes.bool.isRequired,
    height: React.PropTypes.number.isRequired,
    isInterlace: React.PropTypes.bool.isRequired,
    showVerticalScrollBar: React.PropTypes.bool,
    onClickEvent: React.PropTypes.func,
    showSeparator: React.PropTypes.bool.isRequired,
    textPadding: React.PropTypes.number.isRequired,
    selectedTextColor: React.PropTypes.string,
  },

  render: function () {
    var textStyle = {
      lineHeight: this.props.height + 'px',
      // marginLeft: this.props.textPadding,
      paddingLeft: this.props.textPadding,
      paddingRight: this.props.textPadding
    };
    if (this.props.selected) {
      textStyle.color = this.props.selectedTextColor;
    }

    return (<CustomRect
      key={this.props.index}
      {...{
        top: this.props.top,
        left: 0,
        width: this.props.width,
        height: this.props.height,
        borderBottomStyle: this.props.showDivisionLine ? 'solid' : 'none',
        backgroundColor: this.props.selected ? this.props.selectedColor : (this.props.isInterlace ? this.props.interlaceColor : this.props.backgroundColor),
        showSeparator: this.props.showSeparator,
        separatorColor: this.props.separatorColor
      }} onClick={this.props.onClickEvent}>
      <div
        style={textStyle}
      >{util.Text.convertSpaceToNbsp(this.props.text)}</div>
    </CustomRect>);
  }
});

var List = React.createClass({

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    };
  },

  parseText: function () {
    var text = styleHelper.getText(this.props);
    text = util.Text.removeLastEmptyRow(text);
    return util.Text.delimitText(text, util.Text.DM_RETURN);
  },

  additionalItems: function (arr) {
    var count = this.props.h / this.props.itemHeight;
    var i = arr.length;
    if (arr.length < count) {
      for (i; i < count; i++) {
        arr.push('');
      }
    }
  },

  render: function () {
    var textArray = this.parseText();
    var maxValideItemCount = textArray.length;
    var textMarginRight = 10;
    var itemHeight = util.Int(this.props.itemHeight);
    var top;
    var style = {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      position: 'absolute'
    };
    this.additionalItems(textArray);
    styleHelper.StyleUtil(this.props).default(style).background().text().border().align().size();

    if (this.props.verticalScrollbarShow) {
      textMarginRight = 22;
      itemHeight -= 1;
    }
    //console.log(this.props.interactiveData.entry.length);

    return (<div key={this.props.controlID} style={style}>
      {
        textArray.map(function (text, index) {
          top = itemHeight * index;
          return (<ListItem
            key={index}
            top={top}
            index={index}
            interlaceColor={styleHelper.getPropertyValue(this.props, propConst.INTERLACE_COLOR)}
            backgroundColor={styleHelper.getBackgroundColor(this.props)}
            textAlign={style.textAlign}
            textMarginRight={textMarginRight}
            selected={this.state.selectedIndex === index}
            selectedColor={styleHelper.getSelectedColor(this.props)}
            showDivisionLine={styleHelper.getPropertyValue(this.props, propConst.SHOW_H_LINE2)}
            isInterlace={this.props.isInterlace && (index % 2 === 1)}
            height={itemHeight}
            width={styleHelper.getWidth(this.props) - (this.props.verticalScrollbarShow ? 14 : 2)}
            text={text}
            onClickEvent={index < maxValideItemCount ? this._onClick.bind(this, index) : undefined}

            showSeparator={this.props.showSeparator}
            separatorColor={this.props.separatorColor}
            textPadding={this.props.textPadding}
            selectedTextColor={this.props.selectedTextColor || 'none'}
          />);
        }.bind(this))
      }
      {
        this.props.verticalScrollbarShow &&
        <VerticalScrollBar
          value={util.Int(this.props.verticalScrollbarProgress)}
        />
      }
    </div>);
  },

  _onClick: function (index) {
    this.setState({selectedIndex: index});
  },

  componentDidMount: function () {
    var self = this;
    $(ReactDOM.findDOMNode(this)).bind('itemClick', function (e, index) {
      self._onClick(index);
    });
  }
});

module.exports = List;



// WEBPACK FOOTER //
// ./src/views/Components/List.jsx